export const dbdata = [
  {
    title: "Json",
    subtitle: " Json",
    filepath: "/Database/Json.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
  {
    title: "MongoDB Installation",
    subtitle: " MongoDB Installation",
    filepath: "/Database/Mongodb-installation.md",
  },
  {
    title: "MongoDB",
    subtitle: " MongoDB",
    filepath: "/Database/Mongodb.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
  {
    title: "MongoDB query",
    subtitle: " MongoDB query",
    filepath: "/Database/Mongodb-queries.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
  {
    title: "MongoDB- Nodejs Connection",
    subtitle: " MongoDB- Nodejs Connection",
    filepath: "/Database/nodejs-mongodb.md",
  },
];
